export enum AttendanceType{
    PlantProtection = 1,
    ERT = 2,
}